export default "__VITE_ASSET__BkEPfner__"